"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const de_ui_1 = require("@delab-team/de-ui");
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
// import { useStore as useStoreNanoStores } from '@nanostores/react'
const svg_selector_1 = require("../../assets/svg-selector");
const navFooter_module_css_1 = __importDefault(require("./navFooter.module.css"));
const NavFooter = ({ setShowJettonDetail, showJettonDetail }) => {
    const TgObj = sdk_1.default;
    const location = (0, react_router_1.useLocation)();
    const navigate = (0, react_router_1.useNavigate)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [scrolling, setScrolling] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handleScroll = () => {
            setScrolling(true);
            // clearTimeout(timeout)
            const timeout = setTimeout(() => {
                setScrolling(false);
            }, 250);
            return () => clearTimeout(timeout);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const handleStopScrolling = () => {
        // Останавливаем инерционный скролл
        window.document.body.style.overflowY = 'hidden';
        // container.style.overflow = 'hidden'
        // Восстанавливаем скролл через короткое время (например, через 300 миллисекунд)
        setTimeout(() => {
            window.document.body.style.overflowY = 'auto';
        }, 100);
    };
    const homeHandler = () => {
        // window.document.body.scrollTo(0, 0)
        TgObj.HapticFeedback.impactOccurred('medium');
        if (!showJettonDetail) {
            navigate('/');
        }
        TgObj.BackButton.hide();
        TgObj.MainButton.hide();
        setShowJettonDetail(false);
    };
    const swapHandler = () => {
        // window.document.body.scrollTo(0, 0)
        TgObj.HapticFeedback.impactOccurred('medium');
        setShowJettonDetail(false);
        navigate('/swap');
        TgObj.BackButton.hide();
        TgObj.MainButton.hide();
    };
    const appHandler = () => {
        // window.document.body.scrollTo(0, 0)
        TgObj.HapticFeedback.impactOccurred('medium');
        navigate('/apps');
        TgObj.BackButton.hide();
        TgObj.MainButton.hide();
    };
    const settingHandler = () => {
        // window.document.body.scrollTo(0, 0)
        TgObj.HapticFeedback.impactOccurred('medium');
        navigate('/settings');
        TgObj.BackButton.hide();
        TgObj.MainButton.hide();
    };
    return (((0, jsx_runtime_1.jsxs)("div", { className: navFooter_module_css_1.default.navigation, children: [(0, jsx_runtime_1.jsxs)(de_ui_1.Button, { onClick: scrolling ? handleStopScrolling : homeHandler, className: `${navFooter_module_css_1.default.navElement} ${location.pathname === '/' ? navFooter_module_css_1.default.navElementActive : navFooter_module_css_1.default.navElementNonActive}`, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: 'home-icon' }) }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: navFooter_module_css_1.default.navText, children: t('menu.home') })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { onClick: scrolling ? handleStopScrolling : swapHandler, className: `${navFooter_module_css_1.default.navElement} ${location.pathname === '/swap' ? navFooter_module_css_1.default.navElementActive : navFooter_module_css_1.default.navElementNonActive}`, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: 'swap-icon' }) }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: navFooter_module_css_1.default.navText, children: t('menu.swap') })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { onClick: scrolling ? handleStopScrolling : appHandler, className: `${navFooter_module_css_1.default.navElement} ${location.pathname === '/apps' ? navFooter_module_css_1.default.navElementActive : navFooter_module_css_1.default.navElementNonActive}`, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: 'apps-icon' }) }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: navFooter_module_css_1.default.navText, children: t('menu.apps') })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Button, { onClick: scrolling ? handleStopScrolling : settingHandler, className: `${navFooter_module_css_1.default.navElement} ${location.pathname === '/settings' ? navFooter_module_css_1.default.navElementActive : navFooter_module_css_1.default.navElementNonActive}`, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: 'settings-icon' }) }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: navFooter_module_css_1.default.navText, children: t('menu.settings') })] })] })));
};
exports.NavFooter = NavFooter;
